import getConfig from 'next/config'

// cdnVideo is the CDN base for product videos (mp4). See next.config.js publicRuntimeConfig.
export const useCdnBasePath = (fromIo?: boolean) => {
  const config = getConfig().publicRuntimeConfig
  return fromIo ? `${config.cdnVideoNa || config.cdnVideo}` : `${config.cdnVideo}`
}

const cdnBasePathImg = getConfig().publicRuntimeConfig.cdnBasePath

export const videoPath = (url: string, basepath = getConfig().publicRuntimeConfig.cdnVideo) =>
  `${basepath}${url}`

export const videoPathFallback = (url: string) => `${cdnBasePathImg}/${url}`

export const previewVideo = (path = '', basepath = getConfig().publicRuntimeConfig.cdnVideo) =>
  `${basepath}${path}`

export const getFallbackVideoPath = (fileName: string, page_id?: string) => {
  return `${cdnBasePathImg}/c/96x96/p/${page_id || ''}/i/${fileName}`
}
